<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <FeatureFieldAlert required-field="phone" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block ">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Digite e pressione 'ENTER'" @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right" v-if="canCreateCampaign">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newCampaign()">
                      <i class="mdi mdi-plus mr-1"></i> Nova Campanha
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap">
                <thead>
                  <tr>
                    <th width="25%">Campanha</th>
                    <th width="15%">Lista</th>
                    <th width="15%">Progresso</th>
                    <th width="20%">Agendamento</th>
                    <th width="15%">Status</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in campaigns" :key="list.id">
                    <td class="link" @click="editCampaign(list.id)">{{ list.name }}</td>
                    <td class="link" @click="editCampaign(list.id)">{{ list.type_contact }} <small>({{ list.qty_contacts }})</small></td>
                    <td class="link" @click="editCampaign(list.id)">
                      <b-progress max="100" height="2rem" variant="success" v-if="list.progress > 0">
                        <b-progress-bar :value="list.progress">
                          <span>Progresso: <strong>{{ list.progress + '%'}}</strong></span>
                        </b-progress-bar>
                      </b-progress>
                      <span v-if="list.progress === 0" class="badge font-size-11 p-1 badge-secondary" style="min-width: 100%;margin-top:2px;background-color: #d9d9d9 !important">
                          0%
                      </span>
                    </td>
                    <td class="link" @click="editCampaign(list.id)">{{ list.scheduled_at ? list.scheduled_at : 'Sem agendamento'}}</td>
                    <td>
                      <span
                        :class="list.classStatus"
                        class="badge font-size-12 p-2" style="min-width: 120px">
                          {{ list.statusLabel }}
                      </span>
                    </td>
                    <td style="display: flex; gap: 4px;">
                      <button v-if="canCreateCampaign" type="button" @click="detailCampaign(list.id)" class="link btn btn-outline-primary btn-sm"><i class="bx bx-bar-chart-alt-2"></i></button>
                      <button v-if="user.role === 'Admin' && (list.status === 'pending' || list.status === 'scheduled')" type="button" @click="deleteCampaign(list)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <b-sidebar id="sidebar-right" right shadow backdrop bg-variant="white" v-model="exampleTemplate" width="400px" z-index="1050">
      <div class="px-3 py-2">
        <h6 class="mb-3">Preview do template</h6>
        <div class="wa-preview-phone">
          <div class="wa-preview-header-bar">
            <div class="wa-preview-avatar"></div>
            <div class="wa-preview-name-bar"></div>
          </div>
          <div class="wa-preview-body">
            <div class="wa-preview-bubble">
              <img v-if="previewImageUrl" :src="previewImageUrl" style="width:100%;border-radius:6px 6px 0 0;display:block" />
              <div class="wa-preview-content" v-html="formattedMessage"></div>
            </div>
          </div>
        </div>
      </div>
    </b-sidebar>
    <modal-form v-model="modalForm" :idCampaign="idCampaign" ref="formCampaign" @created="updateList" @exampleTemplate="openExample"></modal-form>
    <modal-template v-model="modalTemplate" ref="formTemplate"></modal-template>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import ModalForm from './Form'
import ModalTemplate from '../templates/Form.vue'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import FeatureFieldAlert from '@/components/FeatureFieldAlert'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader,
    ModalForm,
    ModalTemplate,
    FeatureFieldAlert
  },
  name: 'Campanhas',
  page: {
    title: 'Campanhas',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      exampleTemplate: false,
      previewImageUrl: null,
      logMessage: {
        body: null
      },
      timeout: 60000,
      modalForm: false,
      modalTemplate: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      idCampaign: null,
      perPage: 20,
      submitted: false,
      title: 'Campanhas',
      items: [{
        text: 'Campanhas'
      },
      {
        text: 'Listagem',
        active: true
      }
      ]
    }
  },
  mounted () {
    this.updateList()
    this.timeout = setInterval(() => {
      this.updateList()
    }, 60000)
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['hasPermission']),
    ...mapState('campaign', ['campaigns', 'pagination']),
    canCreateCampaign () {
      return this.hasPermission('campaigns.whatsapp.create')
    },
    rows () {
      return this.pagination.total
    },
    formattedMessage () {
      if (this.logMessage.body) {
        let text = this.logMessage.body
        text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        text = text.replace(/\*(.*?)\*/g, '<strong>$1</strong>')
        text = text.replace(/_(.*?)_/g, '<em>$1</em>')
        text = text.replace(/~(.*?)~/g, '<del>$1</del>')
        text = text.replace(/\{\{(\d+)\}\}/g, '<span style="background:rgba(85,110,230,.1);color:#556ee6;padding:1px 4px;border-radius:3px;font-size:11px;font-weight:600">{{$1}}</span>')
        text = text.replace(/\r?\n/g, '<br>')
        return text
      }
      return ''
    }
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  methods: {
    ...mapActions('campaign', {
      getAll: 'getAll',
      delete: 'deleteCampaign',
      changeStatus: 'changeStatus'
    }),
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    openExample (data) {
      this.exampleTemplate = true
      const components = data.components || data || []
      this.previewImageUrl = data.header_image_url || null
      let headerText = ''
      let bodyText = ''
      let footerText = ''
      ;(Array.isArray(components) ? components : []).forEach(c => {
        if (c.type === 'HEADER' && c.format === 'TEXT') headerText = c.text || ''
        else if (c.type === 'BODY') bodyText = c.text || ''
        else if (c.type === 'FOOTER') footerText = c.text || ''
      })
      let body = ''
      if (headerText) body += '*' + headerText + '*\n'
      body += bodyText
      if (footerText) body += '\n\n' + footerText
      this.logMessage = { body }
    },
    openTemplates () {
      this.$refs.formTemplate.open('')
      this.modalTemplate = true
    },
    newCampaign () {
      this.$refs.formCampaign.open('')
      this.modalForm = true
    },
    detailCampaign (id) {
      if (this.canCreateCampaign) {
        this.$router.push({
          name: 'wa-campaign-details',
          params: {
            id: id
          }
        })
      }
    },
    async toggleStatus (id) {
      try {
        await this.changeStatus(id)
        let message = 'Sucesso: Status atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.updateList()
      } catch (err) {
        console.log(err)
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    deleteCampaign (campaign) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluido a campanha: <b>${campaign.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.delete(campaign.id)
            successMessage('Sucesso: Campanha excluída com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup { font-size: 11px !important; }
.table-responsive { min-height: 300px; }
.float-sm-end { float: right; }
.progress { background-color: #d9d9d9 !important; }

/* WhatsApp Preview */
.wa-preview-phone { background: #ECE5DD; border-radius: 14px; overflow: hidden; border: 1px solid #e9ecef; box-shadow: 0 4px 12px rgba(0,0,0,.06); }
.wa-preview-header-bar { background: #075E54; padding: 10px 14px; display: flex; align-items: center; gap: 8px; }
.wa-preview-avatar { width: 28px; height: 28px; border-radius: 50%; background: rgba(255,255,255,.2); }
.wa-preview-name-bar { height: 8px; width: 80px; background: rgba(255,255,255,.4); border-radius: 4px; }
.wa-preview-body { padding: 12px 8px; min-height: 150px; }
.wa-preview-bubble { background: #FFF; border-radius: 0 8px 8px 8px; max-width: 92%; box-shadow: 0 1px 1px rgba(0,0,0,.06); overflow: hidden; }
.wa-preview-content { padding: 10px 12px; font-size: 12.5px; color: #3D4F6F; line-height: 1.5; }
</style>
